import ReactAppController from "./react_app_controller"

export default class extends ReactAppController {

    constructor(props) {
        super(props)
        this.name = "camera_door_releases_app_controller"
    }

    renderApp() {
        const appConfig = {
            buildingId: this.element.getAttribute("data-building-id"),
            locale: this.element.getAttribute("data-locale"),
        }
        this.app = __bmx__initCameraDoorReleasesApp(this.element, appConfig)
    }
}
